// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"604":"6de335b4","613":"db3731ab","743":"9cfb79ac"}[chunkId] + ".chunk.js";
};